// Usuário logado (carregado de /me). Fonte de verdade é o cookie no servidor.
import { api, ApiError, type User } from "./api";

let current: User | null = null;
let loaded = false;
const listeners = new Set<(u: User | null) => void>();

export async function loadSession(): Promise<User | null> {
  try {
    current = await api.me();
  } catch (e) {
    if (!(e instanceof ApiError) || e.status !== 401) console.warn("falha ao carregar sessão", e);
    current = null;
  }
  loaded = true;
  listeners.forEach((l) => l(current));
  return current;
}

export function onSessionChange(l: (u: User | null) => void): () => void {
  listeners.add(l);
  return () => listeners.delete(l);
}

export function currentUser(): User | null {
  return current;
}

export function sessionLoaded(): boolean {
  return loaded;
}

export function setUser(u: User | null): void {
  current = u;
  loaded = true;
  listeners.forEach((l) => l(current));
}

export async function logout(): Promise<void> {
  try {
    await api.logout();
  } finally {
    setUser(null);
  }
}
